module.exports = __webpack_public_path__ + "static/media/thumb_down.45cf719d.png";